<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [style]="{width:'40vw'}"
    [header]="dialog?.header ?? ''">

    <p>

        {{dialog?.message ?? ''}}

    </p>

    <ng-template pTemplate="footer">

        <button
            class="button-primary"
            (click)="click('cancel')">

            {{dialog.leftButton}}

        </button>

        <button
            class="button-primary"
            (click)="click('middle')">

            {{dialog.middleButton}}

        </button>

        <button
            class="button-primary"
            (click)="click('continue')">

            {{dialog.rightButton}}

        </button>

    </ng-template>

</p-dialog>